// This file is auto-generated by @hey-api/openapi-ts

import * as z from "zod";

export const CreatePublicShareLinkRequestSchema = z.object({
    resourceType: z.enum(["booking", "proposal"]),
    resourceId: z.string().min(1),
});

export type CreatePublicShareLinkRequest = z.infer<
    typeof CreatePublicShareLinkRequestSchema
>;

export const PublicShareLinkDataSchema = z.object({
    shareId: z.string(),
    url: z.string(),
    expiresAt: z.iso.datetime(),
});

export type PublicShareLinkData = z.infer<typeof PublicShareLinkDataSchema>;

export const SuccessResponseCreatePublicShareLinkSchema = z.object({
    success: z.literal(true),
    data: PublicShareLinkDataSchema,
});

export type SuccessResponseCreatePublicShareLink = z.infer<
    typeof SuccessResponseCreatePublicShareLinkSchema
>;

/**
 * Path parameters for resolving a share link.
 */
export const PublicSharePathParamsSchema = z.object({
    shareId: z.string().min(1),
});

export type PublicSharePathParams = z.infer<typeof PublicSharePathParamsSchema>;

/**
 * Path parameters for downloading a shared public attachment.
 */
export const PublicShareAttachmentPathParamsSchema = z.object({
    shareId: z.string().min(1),
    attachmentId: z.string().min(1),
});

export type PublicShareAttachmentPathParams = z.infer<
    typeof PublicShareAttachmentPathParamsSchema
>;

export const PublicPriceSchema = z.object({
    amount: z.number(),
    currency: z.string(),
});

export type PublicPrice = z.infer<typeof PublicPriceSchema>;

export const PublicAttachmentSchema = z.object({
    name: z.string(),
    attachmentId: z.string().nullable(),
});

export type PublicAttachment = z.infer<typeof PublicAttachmentSchema>;

export const PublicOptionSchema = z.object({
    id: z.string(),
    title: z.string().optional(),
    description: z.string().optional(),
    imageURLs: z.array(z.string()).optional(),
    confirmed: z.boolean().optional(),
    price: PublicPriceSchema.optional(),
});

export type PublicOption = z.infer<typeof PublicOptionSchema>;

export const PublicBookingSchema = z.object({
    id: z.string(),
    template: z.enum(["accommodation", "general"]),
    offeringCategory: z
        .enum([
            "dining",
            "nightlife",
            "flight",
            "train",
            "accommodation",
            "travelItinerary",
            "transportation",
            "event",
            "localExperience",
            "shopping",
            "wellness",
            "services",
            "other",
        ])
        .optional(),
    title: z.string(),
    description: z.string(),
    headline: z.string().optional(),
    notesForMember: z.string().optional(),
    benefits: z.string().optional(),
    images: z.array(z.string()),
    attachments: z.array(PublicAttachmentSchema),
    website: z.string().optional(),
    phoneNumber: z.string().optional(),
    address: z.string().optional(),
    mapUrl: z.string().optional(),
    confirmed: z.boolean(),
    bookingPolicy: z.string().optional(),
    rooms: z.string().optional(),
    price: PublicPriceSchema.optional(),
    priceDetails: z.string().optional(),
    startTime: z.string().optional(),
    startTimezone: z.string().optional(),
    endTime: z.string().optional(),
    endTimezone: z.string().optional(),
    numberOfGuests: z.number().optional(),
    numberOfNights: z.number().optional(),
    options: z.array(PublicOptionSchema).optional(),
});

export type PublicBooking = z.infer<typeof PublicBookingSchema>;

export const PublicProposalSchema = z.object({
    id: z.string(),
    title: z.string(),
    startDate: z.string().optional(),
    startTime: z.string().optional(),
    endDate: z.string().optional(),
    endTime: z.string().optional(),
    bookings: z.array(PublicBookingSchema),
    numberOfGuests: z.number().optional(),
});

export type PublicProposal = z.infer<typeof PublicProposalSchema>;

export const PublicShareBookingDetailsSchema = z.object({
    tenant: z.string(),
    language: z.string(),
    booking: PublicBookingSchema,
});

export type PublicShareBookingDetails = z.infer<typeof PublicShareBookingDetailsSchema>;

export const PublicShareProposalDetailsSchema = z.object({
    tenant: z.string(),
    language: z.string(),
    proposal: PublicProposalSchema,
});

export type PublicShareProposalDetails = z.infer<
    typeof PublicShareProposalDetailsSchema
>;

export const PublicShareBookingDetailsResponseSchema = z.object({
    success: z.literal(true),
    data: PublicShareBookingDetailsSchema,
});

export type PublicShareBookingDetailsResponse = z.infer<
    typeof PublicShareBookingDetailsResponseSchema
>;

export const PublicShareProposalDetailsResponseSchema = z.object({
    success: z.literal(true),
    data: PublicShareProposalDetailsSchema,
});

export type PublicShareProposalDetailsResponse = z.infer<
    typeof PublicShareProposalDetailsResponseSchema
>;

export const PublicShareErrorResponseSchema = z.object({
    success: z.literal(false),
    message: z.string(),
});

export type PublicShareErrorResponse = z.infer<typeof PublicShareErrorResponseSchema>;

export const JoinWaitlistRequestSchema = z.object({
    firstName: z.string().max(256),
    lastName: z.string().max(256),
    phoneNumber: z.string().max(256),
    email: z.email(),
    refereeName: z.string().max(256).optional(),
    refereeEmail: z.union([z.email().max(256), z.literal("")]).optional(),
    hasReferral: z.literal("on").optional(),
});

export type JoinWaitlistRequest = z.infer<typeof JoinWaitlistRequestSchema>;

export const JoinWaitlistSuccessResponseSchema = z.object({
    success: z.literal(true),
    data: z.null(),
});

export type JoinWaitlistSuccessResponse = z.infer<
    typeof JoinWaitlistSuccessResponseSchema
>;

export const JoinWaitlistErrorResponseSchema = z.object({
    success: z.literal(false),
    message: z.string(),
});

export type JoinWaitlistErrorResponse = z.infer<typeof JoinWaitlistErrorResponseSchema>;

/**
 * Query parameters for GET /check-app-status.
 */
export const CheckAppStatusQuerySchema = z.object({
    version: z.string().min(1).max(64),
    tenant: z.enum([
        "albertine",
        "hugoboss",
        "mastercard",
        "carlo",
        "visa-i2",
        "revolut",
    ]),
    app: z.enum(["native-wrapper", "native", "react"]),
    device: z.enum(["android", "ios"]),
});

export type CheckAppStatusQuery = z.infer<typeof CheckAppStatusQuerySchema>;

/**
 * Empty when no update is required. Hard updates omit throttle fields. Soft updates always include cooldownMinutes and maxDisplays (server defaults when the matched rule has null DB columns).
 */
export const CheckAppStatusDataSchema = z.union([
    z.record(z.string(), z.never()),
    z.object({
        update: z.enum(["hard"]),
        storeUrl: z.url().optional(),
    }),
    z.object({
        update: z.enum(["soft"]),
        storeUrl: z.url().optional(),
        cooldownMinutes: z.int().gte(1),
        maxDisplays: z.int().gte(1),
    }),
]);

export type CheckAppStatusData = z.infer<typeof CheckAppStatusDataSchema>;

export const SuccessResponseCheckAppStatusSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: CheckAppStatusDataSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseCheckAppStatus = z.infer<
    typeof SuccessResponseCheckAppStatusSchema
>;

/**
 * Feedback from a member. App version metadata is optional for clients that do not collect it (e.g. web).
 */
export const MemberSendFeedbackRequestSchema = z.object({
    message: z.string().min(1),
    appVersion: z.string().optional(),
    appBuildNumber: z.string().optional(),
    platform: z.enum(["ios", "android", "web"]).optional(),
});

export type MemberSendFeedbackRequest = z.infer<typeof MemberSendFeedbackRequestSchema>;

/**
 * Path parameters for submitting request feedback.
 */
export const SendRequestFeedbackPathParamsSchema = z.object({
    requestId: z.string().min(1),
});

export type SendRequestFeedbackPathParams = z.infer<
    typeof SendRequestFeedbackPathParamsSchema
>;

/**
 * Path parameters for skipping request feedback.
 */
export const SkipRequestFeedbackPathParamsSchema = z.object({
    requestId: z.string().min(1),
});

export type SkipRequestFeedbackPathParams = z.infer<
    typeof SkipRequestFeedbackPathParamsSchema
>;

/**
 * Path parameters for fetching a member request.
 */
export const GetMemberRequestPathParamsSchema = z.object({
    requestId: z.string().min(1),
});

export type GetMemberRequestPathParams = z.infer<
    typeof GetMemberRequestPathParamsSchema
>;

/**
 * Path parameters for submitting booking feedback.
 */
export const SendBookingFeedbackPathParamsSchema = z.object({
    bookingId: z.string().min(1),
});

export type SendBookingFeedbackPathParams = z.infer<
    typeof SendBookingFeedbackPathParamsSchema
>;

/**
 * Member rating and/or free-text feedback for a request.
 */
export const SendRequestFeedbackRequestSchema = z.object({
    rating: z.int().gte(1).lte(5).optional(),
    feedback: z.string().max(1024).optional(),
});

export type SendRequestFeedbackRequest = z.infer<
    typeof SendRequestFeedbackRequestSchema
>;

/**
 * Member rating and/or free-text feedback for a booking.
 */
export const SendBookingFeedbackRequestSchema = z.object({
    rating: z.int().gte(1).lte(5).optional(),
    feedback: z.string().max(1024).optional(),
});

export type SendBookingFeedbackRequest = z.infer<
    typeof SendBookingFeedbackRequestSchema
>;

/**
 * Path parameters for fetching a proposal.
 */
export const ProposalPathParamsSchema = z.object({
    proposalId: z.string().min(1),
});

export type ProposalPathParams = z.infer<typeof ProposalPathParamsSchema>;

/**
 * Query parameters for listing proposals.
 */
export const ListProposalsQuerySchema = z.object({
    cursor: z.string().min(1).optional(),
    pageSize: z.coerce.number().int().gte(1).lte(50).optional().default(20),
});

export type ListProposalsQuery = z.infer<typeof ListProposalsQuerySchema>;

/**
 * Query parameters for listing member requests.
 */
export const ListMemberRequestsQuerySchema = z.object({
    cursor: z.string().min(1).optional(),
    pageSize: z.coerce.number().int().gte(1).lte(50).optional().default(20),
});

export type ListMemberRequestsQuery = z.infer<typeof ListMemberRequestsQuerySchema>;

/**
 * Offering category for a request or booking.
 */
export const OfferingCategorySchema = z.enum([
    "dining",
    "nightlife",
    "flight",
    "train",
    "accommodation",
    "travelItinerary",
    "transportation",
    "event",
    "localExperience",
    "shopping",
    "wellness",
    "services",
    "other",
]);

export type OfferingCategory = z.infer<typeof OfferingCategorySchema>;

/**
 * Compact request row for member history lists.
 */
export const ConciergeRequestListItemSchema = z.object({
    id: z.string().min(1),
    title: z.string().optional(),
    createdAt: z.iso.datetime(),
    previewImageUrl: z.string().nullable(),
    offeringCategory: OfferingCategorySchema.nullable(),
    agentId: z.string().nullable(),
    agentName: z.string().nullable(),
});

export type ConciergeRequestListItem = z.infer<typeof ConciergeRequestListItemSchema>;

export const ConciergeRequestListSchema = z.object({
    items: z.array(ConciergeRequestListItemSchema),
    nextCursor: z.string().optional(),
});

export type ConciergeRequestList = z.infer<typeof ConciergeRequestListSchema>;

export const SuccessResponseRequestListSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: ConciergeRequestListSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseRequestList = z.infer<
    typeof SuccessResponseRequestListSchema
>;

/**
 * A wall-clock time of day.
 */
export const ClockTimeSchema = z.object({
    hours: z.int().gte(0).lte(23),
    minutes: z.int().gte(0).lte(59),
});

export type ClockTime = z.infer<typeof ClockTimeSchema>;

/**
 * Next action waiting on the request.
 */
export const RequestDeadlineStepSchema = z.enum([
    "revisit_request",
    "send_status_update",
    "send_status_update_internal",
    "send_proposal",
    "send_booking_confirmation",
    "wait_for_member_response",
    "wait_for_supplier_response",
    "check_on_pending_payment",
    "no_further_action",
]);

export type RequestDeadlineStep = z.infer<typeof RequestDeadlineStepSchema>;

/**
 * Next deadline for a request thread, present only when a step is set.
 */
export const RequestConversationDeadlineSchema = z.object({
    step: RequestDeadlineStepSchema,
    at: z.iso.datetime().nullable(),
});

export type RequestConversationDeadline = z.infer<
    typeof RequestConversationDeadlineSchema
>;

/**
 * Lifestyle manager assigned to the request.
 */
export const RequestConversationAssignedAgentSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1),
});

export type RequestConversationAssignedAgent = z.infer<
    typeof RequestConversationAssignedAgentSchema
>;

/**
 * The member's general conversation and its unread count.
 */
export const GeneralConversationSummarySchema = z.object({
    id: z.string().min(1),
    unreadMessagesCount: z.int().gte(0),
});

export type GeneralConversationSummary = z.infer<
    typeof GeneralConversationSummarySchema
>;

/**
 * The data payload of a conversation-inbox SSE event. The event type is determined by the SSE `event` field (currently `heartbeat`), and the event ID is in the SSE `id` field.
 */
export const ConversationsEventPayloadSchema = z.record(z.string(), z.never());

export type ConversationsEventPayload = z.infer<typeof ConversationsEventPayloadSchema>;

/**
 * Rating and optional free-text feedback for this request.
 */
export const MemberRequestFeedbackSchema = z.object({
    rating: z.int().gte(1).lte(5).nullable(),
    feedback: z.string().max(1024).nullable(),
    timestamp: z.iso.datetime().nullable(),
});

export type MemberRequestFeedback = z.infer<typeof MemberRequestFeedbackSchema>;

/**
 * Member-facing request details for a single owned request.
 */
export const MemberRequestSchema = z.object({
    id: z.string().min(1),
    title: z.string().nullable(),
    createdAt: z.iso.datetime(),
    previewImageUrl: z.string().nullable(),
    offeringCategory: OfferingCategorySchema.nullable(),
    startDate: z.string().nullable(),
    startTime: z.string().nullable(),
    endDate: z.string().nullable(),
    endTime: z.string().nullable(),
    numberOfGuests: z.number().nullable(),
    location: z.string().nullable(),
    status: z.enum(["new", "draft", "open", "confirmed", "closed"]),
    closedAt: z.iso.datetime().nullable(),
    feedback: MemberRequestFeedbackSchema,
});

export type MemberRequest = z.infer<typeof MemberRequestSchema>;

export const MemberRequestResponseSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: MemberRequestSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type MemberRequestResponse = z.infer<typeof MemberRequestResponseSchema>;

/**
 * i18n key for the Discover greeting headline.
 */
export const SnippetPageTitleSchema = z.enum([
    "snippets.title.new_message",
    "snippets.title.new_messages",
    "snippets.title.waiting_for_feedback",
    "snippets.title.working_on_request",
    "snippets.title.working_on_requests",
    "snippets.title.how_can_we_help",
]);

export type SnippetPageTitle = z.infer<typeof SnippetPageTitleSchema>;

export const RequestSnippetStateSchema = z.enum([
    "unread",
    "awaiting_reply",
    "replied",
    "new_request",
    "in_progress",
]);

export type RequestSnippetState = z.infer<typeof RequestSnippetStateSchema>;

export const SnippetSectionKeySchema = z.enum(["please_review", "in_progress", "none"]);

export type SnippetSectionKey = z.infer<typeof SnippetSectionKeySchema>;

export const MessagePreviewPlaceholderKeySchema = z.enum([
    "message.preview.shared_image",
    "message.preview.shared_document",
    "message.preview.shared_audio",
    "message.preview.shared_proposal",
    "message.preview.shared_booking",
]);

export type MessagePreviewPlaceholderKey = z.infer<
    typeof MessagePreviewPlaceholderKeySchema
>;

export const MessagePreviewMediaTypeSchema = z.enum([
    "image",
    "document",
    "audio",
    "proposal",
    "booking",
]);

export type MessagePreviewMediaType = z.infer<typeof MessagePreviewMediaTypeSchema>;

export const ConciergeMessagePreviewSchema = z.object({
    senderId: z.string().nullable(),
    senderName: z.string(),
    sentByMember: z.boolean(),
    text: z.string().nullable(),
    placeholderKey: MessagePreviewPlaceholderKeySchema.nullable(),
    mediaType: MessagePreviewMediaTypeSchema.nullable(),
    mediaImageUrls: z.array(z.url()).max(2),
    isConfirmedBooking: z.boolean(),
});

export type ConciergeMessagePreview = z.infer<typeof ConciergeMessagePreviewSchema>;

export const ConciergeRequestSnippetSchema = z.object({
    type: z.literal("request"),
    requestId: z.string().min(1),
    title: z.string().nullable(),
    startDate: z.string().nullable(),
    startTime: z.string().nullable(),
    endDate: z.string().nullable(),
    endTime: z.string().nullable(),
    guestCount: z.int().nullable(),
    state: RequestSnippetStateSchema,
    unreadCount: z.int().gte(0),
    assignedToId: z.string().nullable(),
    assignedToName: z.string().nullable(),
    message: ConciergeMessagePreviewSchema.nullable(),
    nextUpdateAt: z.iso.datetime().nullable(),
    sectionKey: SnippetSectionKeySchema,
});

export type ConciergeRequestSnippet = z.infer<typeof ConciergeRequestSnippetSchema>;

export const ConciergeGeneralChatSnippetSchema = z.object({
    type: z.literal("general_chat"),
    state: z.enum(["unread", "read"]),
    unreadCount: z.int().gte(0),
    message: ConciergeMessagePreviewSchema.nullable(),
    sectionKey: SnippetSectionKeySchema,
});

export type ConciergeGeneralChatSnippet = z.infer<
    typeof ConciergeGeneralChatSnippetSchema
>;

export const SnippetSchema = z.union([
    z
        .object({
            type: z.literal("request"),
        })
        .and(ConciergeRequestSnippetSchema),
    z
        .object({
            type: z.literal("general_chat"),
        })
        .and(ConciergeGeneralChatSnippetSchema),
]);

export type Snippet = z.infer<typeof SnippetSchema>;

/**
 * Discover snippet list for the authenticated member.
 */
export const ListMemberSnippetsSchema = z.object({
    pageTitle: SnippetPageTitleSchema,
    defaultVisibleCount: z.int().gte(0),
    items: z.array(SnippetSchema),
});

export type ListMemberSnippets = z.infer<typeof ListMemberSnippetsSchema>;

export const SuccessResponseListMemberSnippetsSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: ListMemberSnippetsSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseListMemberSnippets = z.infer<
    typeof SuccessResponseListMemberSnippetsSchema
>;

/**
 * Member-facing request data for a proposal.
 */
export const ConciergeProposalRequestSchema = z.object({
    id: z.string().min(1),
    title: z.string().optional(),
    startDate: z.string().optional(),
    startTime: z.string().optional(),
    endDate: z.string().optional(),
    endTime: z.string().optional(),
    numberOfGuests: z.number().optional(),
    status: z.enum(["new", "draft", "open", "confirmed", "closed"]),
});

export type ConciergeProposalRequest = z.infer<typeof ConciergeProposalRequestSchema>;

/**
 * Compact proposal row for member history lists.
 */
export const ConciergeProposalListItemSchema = z.object({
    id: z.string().min(1),
    title: z.string().optional(),
    firstSentAt: z.iso.datetime(),
    optionCount: z.int().gte(0),
    previewImageUrls: z.array(z.string()),
});

export type ConciergeProposalListItem = z.infer<typeof ConciergeProposalListItemSchema>;

export const ConciergeProposalImageSchema = z.object({
    url: z.string(),
    croppedImageURL: z.string().optional(),
});

export type ConciergeProposalImage = z.infer<typeof ConciergeProposalImageSchema>;

export const ConciergeProposalAttachmentSchema = z.object({
    filename: z.string().optional(),
    url: z.string(),
});

export type ConciergeProposalAttachment = z.infer<
    typeof ConciergeProposalAttachmentSchema
>;

export const ConciergeGeoPointSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
});

export type ConciergeGeoPoint = z.infer<typeof ConciergeGeoPointSchema>;

export const ConciergeProposalPriceSchema = z.object({
    amount: z.number().gte(0),
    currency: z.string().length(3),
});

export type ConciergeProposalPrice = z.infer<typeof ConciergeProposalPriceSchema>;

export const ConciergeProposalOptionSchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string().optional(),
    images: z.array(ConciergeProposalImageSchema).optional(),
    confirmed: z.boolean().optional(),
    price: ConciergeProposalPriceSchema.optional(),
});

export type ConciergeProposalOption = z.infer<typeof ConciergeProposalOptionSchema>;

/**
 * Member-facing booking data shown as a proposal option.
 */
export const ConciergeProposalBookingSchema = z.object({
    id: z.string().min(1),
    title: z.string().optional(),
    description: z.string().optional(),
    offeringCategory: OfferingCategorySchema.optional(),
    imageURL: z.string().optional(),
    croppedImageURL: z.string().optional(),
    images: z.array(ConciergeProposalImageSchema).optional(),
    attachments: z.array(ConciergeProposalAttachmentSchema).optional(),
    startTime: z.iso.datetime().optional(),
    startTimezone: z.string().optional(),
    endTime: z.iso.datetime().optional(),
    endTimezone: z.string().optional(),
    numberOfGuests: z.number().optional(),
    numberOfNights: z.number().optional(),
    website: z.string().optional(),
    address: z.string().optional(),
    phoneNumber: z.string().optional(),
    geoPoint: ConciergeGeoPointSchema.optional(),
    googleUrl: z.string().optional(),
    notesForMember: z.string().optional(),
    rooms: z.string().optional(),
    benefits: z.string().optional(),
    price: ConciergeProposalPriceSchema.optional(),
    priceDetails: z.string().optional(),
    headline: z.string().optional(),
    bookingPolicy: z.string().optional(),
    reservationStatus: z
        .enum(["unselected", "prebooked", "confirmed", "cancelled"])
        .optional(),
    options: z.array(ConciergeProposalOptionSchema).optional(),
});

export type ConciergeProposalBooking = z.infer<typeof ConciergeProposalBookingSchema>;

export const ConciergeProposalSchema = z.object({
    request: ConciergeProposalRequestSchema,
    bookings: z.array(ConciergeProposalBookingSchema),
});

export type ConciergeProposal = z.infer<typeof ConciergeProposalSchema>;

export const SuccessResponseProposalSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: ConciergeProposalSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseProposal = z.infer<typeof SuccessResponseProposalSchema>;

export const ConciergeProposalListSchema = z.object({
    items: z.array(ConciergeProposalListItemSchema),
    nextCursor: z.string().optional(),
});

export type ConciergeProposalList = z.infer<typeof ConciergeProposalListSchema>;

export const SuccessResponseProposalListSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: ConciergeProposalListSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseProposalList = z.infer<
    typeof SuccessResponseProposalListSchema
>;

export const MemberServiceHoursEntrySchema = z.object({
    opening: z.string(),
    closing: z.string(),
});

export type MemberServiceHoursEntry = z.infer<typeof MemberServiceHoursEntrySchema>;

/**
 * Map of weekday names to service hours. Only days with service are included.
 */
export const MemberServiceHoursMapSchema = z.object({
    monday: MemberServiceHoursEntrySchema.optional(),
    tuesday: MemberServiceHoursEntrySchema.optional(),
    wednesday: MemberServiceHoursEntrySchema.optional(),
    thursday: MemberServiceHoursEntrySchema.optional(),
    friday: MemberServiceHoursEntrySchema.optional(),
    saturday: MemberServiceHoursEntrySchema.optional(),
    sunday: MemberServiceHoursEntrySchema.optional(),
});

export type MemberServiceHoursMap = z.infer<typeof MemberServiceHoursMapSchema>;

export const MemberServiceHoursPayloadSchema = z.object({
    id: z.string(),
    timezone: z.string(),
    serviceHours: MemberServiceHoursMapSchema,
});

export type MemberServiceHoursPayload = z.infer<typeof MemberServiceHoursPayloadSchema>;

export const SuccessResponseMemberServiceHoursSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: MemberServiceHoursPayloadSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseMemberServiceHours = z.infer<
    typeof SuccessResponseMemberServiceHoursSchema
>;

/**
 * Payload for updating a member's personal information. All properties are optional; only provided fields are written.
 */
export const UpdatePersonalInfoRequestSchema = z.object({
    title: z.string().optional(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
});

export type UpdatePersonalInfoRequest = z.infer<typeof UpdatePersonalInfoRequestSchema>;

export const UpdateOnboardingGreetingsNameRequestSchema = z.object({
    greetingsName: z.string().min(1),
});

export type UpdateOnboardingGreetingsNameRequest = z.infer<
    typeof UpdateOnboardingGreetingsNameRequestSchema
>;

export const UpdateOnboardingTopCitiesRequestSchema = z.object({
    googlePlaceIds: z.array(z.string().min(1)).max(3),
});

export type UpdateOnboardingTopCitiesRequest = z.infer<
    typeof UpdateOnboardingTopCitiesRequestSchema
>;

export const UpdateOnboardingConciergeExperienceRequestSchema = z.object({
    hasUsedConcierge: z.enum(["yes", "no", "maybe"]),
    hasUsedConciergeFor: z.string().nullish(),
});

export type UpdateOnboardingConciergeExperienceRequest = z.infer<
    typeof UpdateOnboardingConciergeExperienceRequestSchema
>;

export const UpdateOnboardingTravelPlansRequestSchema = z.object({
    anyUpcomingTravelPlans: z.enum(["yes", "no", "some"]),
    upcomingTravelQuery: z.string().nullish(),
});

export type UpdateOnboardingTravelPlansRequest = z.infer<
    typeof UpdateOnboardingTravelPlansRequestSchema
>;

export const UpdateOnboardingDiningPlansRequestSchema = z.object({
    anyUpcomingDiningPlans: z.enum(["yes", "no"]),
    upcomingDiningQuery: z.string().nullish(),
});

export type UpdateOnboardingDiningPlansRequest = z.infer<
    typeof UpdateOnboardingDiningPlansRequestSchema
>;

/**
 * Payload for changing a member's preferred service language.
 */
export const ChangeMyServiceLanguageRequestSchema = z.object({
    serviceLanguage: z.enum(["en", "de", "fr"]),
});

export type ChangeMyServiceLanguageRequest = z.infer<
    typeof ChangeMyServiceLanguageRequestSchema
>;

/**
 * Payload for managing push notification tokens for a device. When enabled is true, token is required.
 */
export const ManagePushNotificationTokensRequestSchema = z.object({
    deviceId: z.string().min(1),
    token: z.string().min(1).optional(),
    enabled: z.boolean(),
});

export type ManagePushNotificationTokensRequest = z.infer<
    typeof ManagePushNotificationTokensRequestSchema
>;

/**
 * Payload for updating a member's device information. The platform determines which fields are written to the member document. Omitted or null optional fields are left unchanged; only non-null string values are written.
 */
export const MemberSetOwnDeviceInfoRequestSchema = z.object({
    platform: z.enum(["ios", "android", "web"]),
    appVersion: z.string().optional(),
    osVersion: z.string().nullish(),
    deviceName: z.string().nullish(),
    webUserAgent: z.string().nullish(),
});

export type MemberSetOwnDeviceInfoRequest = z.infer<
    typeof MemberSetOwnDeviceInfoRequestSchema
>;

/**
 * Payload for changing a member's phone number.
 */
export const ChangeMyPhoneNumberRequestSchema = z.object({
    phoneNumber: z.string().min(1),
});

export type ChangeMyPhoneNumberRequest = z.infer<
    typeof ChangeMyPhoneNumberRequestSchema
>;

/**
 * Payload for changing a member's email address.
 */
export const ChangeMyEmailRequestSchema = z.object({
    email: z.string().min(1),
});

export type ChangeMyEmailRequest = z.infer<typeof ChangeMyEmailRequestSchema>;

/**
 * The specific marketing permission a member can consent to.
 */
export const MarketingPermissionKeySchema = z.enum([
    "receive_survey",
    "receive_newsletter",
    "terms_and_conditions",
    "privacy_policy",
]);

export type MarketingPermissionKey = z.infer<typeof MarketingPermissionKeySchema>;

/**
 * The mechanism used by the member to give or revoke consent.
 */
export const MarketingPermissionMethodSchema = z.enum([
    "receive_survey_toggle",
    "privacy_policy_registration_checkbox",
    "terms_and_conditions_registration_checkbox",
    "receive_newsletter_registration_checkbox",
    "receive_survey_onboarding_button",
]);

export type MarketingPermissionMethod = z.infer<typeof MarketingPermissionMethodSchema>;

/**
 * Current state of a marketing permission. "unset" means the member has never granted or revoked it.
 */
export const MarketingPermissionStateSchema = z.enum(["unset", "granted", "revoked"]);

export type MarketingPermissionState = z.infer<typeof MarketingPermissionStateSchema>;

export const MarketingPermissionSchema = z.object({
    permissionKey: MarketingPermissionKeySchema,
    state: MarketingPermissionStateSchema,
});

export type MarketingPermission = z.infer<typeof MarketingPermissionSchema>;

/**
 * Payload for granting or revoking a single marketing permission.
 */
export const SetMarketingPermissionRequestSchema = z.object({
    permissionKey: MarketingPermissionKeySchema,
    action: z.enum(["grant", "revoke"]),
    method: MarketingPermissionMethodSchema,
});

export type SetMarketingPermissionRequest = z.infer<
    typeof SetMarketingPermissionRequestSchema
>;

export const SuccessResponseMarketingPermissionsSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: z.array(MarketingPermissionSchema),
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseMarketingPermissions = z.infer<
    typeof SuccessResponseMarketingPermissionsSchema
>;

export const SuccessResponseSetMarketingPermissionSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: MarketingPermissionSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseSetMarketingPermission = z.infer<
    typeof SuccessResponseSetMarketingPermissionSchema
>;

/**
 * Payload for setting the last rated request.
 */
export const MemberSetLastRatedRequestRequestSchema = z.object({
    requestId: z.string().min(1),
});

export type MemberSetLastRatedRequestRequest = z.infer<
    typeof MemberSetLastRatedRequestRequestSchema
>;

export const DeviceLocationSchema = z.object({
    latitude: z.number(),
    longitude: z.number(),
    place: z
        .object({
            city: z.string(),
            isoCountryCode: z.string(),
        })
        .optional(),
});

export type DeviceLocation = z.infer<typeof DeviceLocationSchema>;

/**
 * Payload for updating a member's device location. Pass null for deviceLocation to clear the location.
 */
export const MemberSetOwnDeviceLocationRequestSchema = z.object({
    deviceLocation: DeviceLocationSchema.nullable(),
});

export type MemberSetOwnDeviceLocationRequest = z.infer<
    typeof MemberSetOwnDeviceLocationRequestSchema
>;

export const SuccessResponseEmptySchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: z.null(),
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseEmpty = z.infer<typeof SuccessResponseEmptySchema>;

/**
 * Concierge shell identity for the authenticated member. Intentionally excludes conversation unread state, membership renewal, and agent-only fields.
 */
export const MemberMeSchema = z.object({
    id: z.string(),
    conversationId: z.string(),
    title: z.string().nullable(),
    firstName: z.string(),
    lastName: z.string(),
    greetingsName: z.string().nullable(),
    serviceLanguage: z
        .union([z.literal("en"), z.literal("de"), z.literal("fr")])
        .nullable(),
    hasOnboardingShown: z.boolean(),
    email: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    createdAt: z.iso.datetime(),
    shouldShowChatPopover: z.boolean().optional(),
    hasLoggedIn: z.boolean(),
});

export type MemberMe = z.infer<typeof MemberMeSchema>;

export const SuccessResponseMemberMeSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: MemberMeSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseMemberMe = z.infer<typeof SuccessResponseMemberMeSchema>;

/**
 * none: no membership. trial: trial period. active: paid and not cancelled. cancelled: membership has a cancellation.
 */
export const MemberMeMembershipStatusSchema = z.enum([
    "none",
    "trial",
    "active",
    "cancelled",
]);

export type MemberMeMembershipStatus = z.infer<typeof MemberMeMembershipStatusSchema>;

/**
 * Member-facing membership status and period end date.
 */
export const MemberMeMembershipSchema = z.object({
    status: MemberMeMembershipStatusSchema,
    endDate: z.iso.date().nullable(),
});

export type MemberMeMembership = z.infer<typeof MemberMeMembershipSchema>;

export const SuccessResponseMemberMeMembershipSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: MemberMeMembershipSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseMemberMeMembership = z.infer<
    typeof SuccessResponseMemberMeMembershipSchema
>;

/**
 * Philanthropy contribution amounts (trees, kelp biomass, and habitat).
 */
export const ContributionAmountsSchema = z.object({
    trees: z.int().gte(0),
    kilograms: z.int().gte(0),
    squareMeters: z.int().gte(0),
});

export type ContributionAmounts = z.infer<typeof ContributionAmountsSchema>;

/**
 * The authenticated member's philanthropy contribution amounts and the community totals shown with them.
 */
export const MemberMeContributionTotalSchema = z.object({
    trees: z.int().gte(0),
    kilograms: z.int().gte(0),
    squareMeters: z.int().gte(0),
    total: ContributionAmountsSchema,
});

export type MemberMeContributionTotal = z.infer<typeof MemberMeContributionTotalSchema>;

export const SuccessResponseMemberMeContributionTotalSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: MemberMeContributionTotalSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseMemberMeContributionTotal = z.infer<
    typeof SuccessResponseMemberMeContributionTotalSchema
>;

/**
 * A request eligible for member feedback, with optional booking.
 */
export const FeedbackCandidateSchema = z.object({
    requestId: z.string(),
    bookingId: z.string().nullable(),
    closedAt: z.iso.datetime(),
    category: z.string().nullable(),
    outcome: z.string().nullable(),
    bookingOutcome: z.string().nullable(),
});

export type FeedbackCandidate = z.infer<typeof FeedbackCandidateSchema>;

/**
 * List of requests eligible for feedback, sorted by priority.
 */
export const ListFeedbackCandidatesDataSchema = z.object({
    items: z.array(FeedbackCandidateSchema),
});

export type ListFeedbackCandidatesData = z.infer<
    typeof ListFeedbackCandidatesDataSchema
>;

export const SuccessResponseListFeedbackCandidatesSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: ListFeedbackCandidatesDataSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseListFeedbackCandidates = z.infer<
    typeof SuccessResponseListFeedbackCandidatesSchema
>;

/**
 * Path parameters for concierge message attachment download.
 */
export const ConciergeMessageAttachmentPathParamsSchema = z.object({
    messageId: z.string().min(1),
});

export type ConciergeMessageAttachmentPathParams = z.infer<
    typeof ConciergeMessageAttachmentPathParamsSchema
>;

/**
 * Path parameters for setting or removing a member message reaction.
 */
export const SetMessageReactionPathParamsSchema = z.object({
    messageId: z.string().min(1),
});

export type SetMessageReactionPathParams = z.infer<
    typeof SetMessageReactionPathParamsSchema
>;

/**
 * Emoji reaction a member can attach to a chat message.
 */
export const EmojiReactionSchema = z.enum(["👍", "👎", "🙏", "❤️", "😊", "😞", "✅"]);

export type EmojiReaction = z.infer<typeof EmojiReactionSchema>;

/**
 * Member emoji reaction to set on a chat message.
 */
export const SetMessageReactionRequestSchema = z.object({
    reaction: EmojiReactionSchema,
});

export type SetMessageReactionRequest = z.infer<typeof SetMessageReactionRequestSchema>;

/**
 * attachmentIndex selects which attachment on the message to stream (0-based, decimal string). Response filename and Content-Type come from Firestore.
 */
export const DownloadMessageAttachmentQuerySchema = z.object({
    attachmentIndex: z.string().regex(/^(0|[1-9][0-9]*)$/),
});

export type DownloadMessageAttachmentQuery = z.infer<
    typeof DownloadMessageAttachmentQuerySchema
>;

export const ErrorResponseSchema = z.object({
    status: z.int(),
    success: z.literal(false),
    error: z.string(),
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type ErrorResponse = z.infer<typeof ErrorResponseSchema>;

/**
 * Stable, machine-readable identifier for the specific business error, for clients to branch on instead of the human-readable message.
 */
export const RegisterMastercardMemberErrorCodeSchema = z.enum([
    "card-not-eligible",
    "duplicate-phone-or-email",
    "invalid-phone-number",
]);

export type RegisterMastercardMemberErrorCode = z.infer<
    typeof RegisterMastercardMemberErrorCodeSchema
>;

export const RegisterMastercardMemberErrorResponseSchema = ErrorResponseSchema.and(
    z.object({
        code: RegisterMastercardMemberErrorCodeSchema.optional(),
    }),
);

export type RegisterMastercardMemberErrorResponse = z.infer<
    typeof RegisterMastercardMemberErrorResponseSchema
>;

/**
 * Request payload for registering a new Mastercard member.
 */
export const RegisterMastercardMemberRequestSchema = z.object({
    cardNumberId: z.string().min(1),
    phoneNumber: z.string().min(1),
});

export type RegisterMastercardMemberRequest = z.infer<
    typeof RegisterMastercardMemberRequestSchema
>;

export const RegisterMastercardMemberResponseSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: z.object({
        memberId: z.string(),
    }),
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type RegisterMastercardMemberResponse = z.infer<
    typeof RegisterMastercardMemberResponseSchema
>;

/**
 * Details submitted from the Revolut perks landing page sign-up form.
 */
export const RegisterRevolutMemberRequestSchema = z.object({
    revolutUserId: z.string().min(1),
    promoCode: z.string().regex(/^ALB-REV-[a-zA-Z0-9]+$/),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    email: z.email(),
    phoneNumber: z.string().min(1),
    title: z.string().optional(),
});

export type RegisterRevolutMemberRequest = z.infer<
    typeof RegisterRevolutMemberRequestSchema
>;

export const RegisterRevolutMemberResponseSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: z.object({
        memberId: z.string(),
        isExisting: z.boolean(),
    }),
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type RegisterRevolutMemberResponse = z.infer<
    typeof RegisterRevolutMemberResponseSchema
>;

/**
 * Stable, machine-readable identifier for the specific business error, for clients to branch on instead of the human-readable message.
 */
export const RegisterRevolutMemberErrorCodeSchema = z.enum([
    "invalid-promo-code",
    "promo-code-already-used",
    "multiple-members-found",
    "member-creation-failed",
    "existing-member-other-tenant",
]);

export type RegisterRevolutMemberErrorCode = z.infer<
    typeof RegisterRevolutMemberErrorCodeSchema
>;

export const RegisterRevolutMemberErrorResponseSchema = ErrorResponseSchema.and(
    z.object({
        code: RegisterRevolutMemberErrorCodeSchema.optional(),
    }),
);

export type RegisterRevolutMemberErrorResponse = z.infer<
    typeof RegisterRevolutMemberErrorResponseSchema
>;

export const GetRevolutPromoCodeRedemptionQuerySchema = z.object({
    revolutUserId: z.string().min(1),
    promoCode: z.string().min(1),
});

export type GetRevolutPromoCodeRedemptionQuery = z.infer<
    typeof GetRevolutPromoCodeRedemptionQuerySchema
>;

export const GetRevolutPromoCodeRedemptionResponseSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: z.object({
        used: z.boolean(),
    }),
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type GetRevolutPromoCodeRedemptionResponse = z.infer<
    typeof GetRevolutPromoCodeRedemptionResponseSchema
>;

export const GetEligibilityWidgetParamsResponseSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: z.object({
        vendorCode: z.string(),
        accessToken: z.string(),
        widgetSrcUrl: z.string(),
    }),
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type GetEligibilityWidgetParamsResponse = z.infer<
    typeof GetEligibilityWidgetParamsResponseSchema
>;

export const GetMastercardMemberRegistrationStatusResponseSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: z.object({
        status: z.enum(["pending", "completed", "failed"]),
    }),
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type GetMastercardMemberRegistrationStatusResponse = z.infer<
    typeof GetMastercardMemberRegistrationStatusResponseSchema
>;

export const CatalogItemGooglePlaceDataSchema = z.object({
    rating: z.number().nullable(),
    userRatingCount: z.int().nullable(),
    googleMapsUri: z.string().nullable(),
});

export type CatalogItemGooglePlaceData = z.infer<
    typeof CatalogItemGooglePlaceDataSchema
>;

/**
 * Tag associated with a catalog item.
 */
export const CatalogItemTagSchema = z.enum([
    "price:free",
    "price:inexpensive",
    "price:moderate",
    "price:expensive",
    "price:very-expensive",
    "type:restaurant",
    "type:cafe",
    "type:pop-up",
    "type:bar",
    "type:pub",
    "type:wine-bar",
    "type:cocktail-bar",
    "type:rooftop",
    "type:nightclub",
    "type:live-music",
    "type:commercial-airline",
    "type:private-airline",
    "type:hotel",
    "type:villa",
    "type:apartment",
    "type:house",
    "type:resort",
    "type:yacht",
    "type:bed-and-breakfast",
    "type:car-rental",
    "type:car-transfer",
    "type:boat-rental",
    "type:charter-boat",
    "type:helicopter",
    "type:water-taxi",
    "type:sports",
    "type:theatre",
    "type:music",
    "type:fashion",
    "type:art",
    "type:dance",
    "type:museum",
    "type:art-gallery",
    "type:historical",
    "type:tourist-attraction",
    "type:must-do",
    "type:hidden-gem",
    "type:outdoors",
    "type:bookshop",
    "type:watches",
    "type:corporate-gifts",
    "type:personal-gifts",
    "type:collectibles",
    "type:spa",
    "type:sauna",
    "type:yoga",
    "type:ayurveda",
    "type:reiki",
    "type:massage",
    "type:beauty-salon",
    "type:personal-trainer",
    "type:retreat",
    "type:surfing",
    "type:wellness-hotel",
    "type:workout-studio",
    "type:flower-delivery",
    "type:cleaning-service",
    "type:moving-service",
    "type:real-estate",
    "type:education",
    "type:childcare",
    "type:bakery",
    "type:food-court",
    "vibe:boutique",
    "vibe:casual",
    "vibe:elegant",
    "vibe:high-end",
    "vibe:local-and-authentic",
    "vibe:luxury",
    "vibe:modern",
    "vibe:quirky",
    "vibe:romantic",
    "vibe:touristy",
    "vibe:traditional",
    "vibe:trendy",
    "vibe:fine-dining",
    "vibe:intimate",
    "goodFor:business",
    "goodFor:couples",
    "goodFor:dates",
    "goodFor:families",
    "goodFor:foodies",
    "goodFor:groups",
    "goodFor:locals",
    "goodFor:parties",
    "goodFor:private-dining",
    "goodFor:tourists",
    "goodFor:vegans",
    "goodFor:vegetarians",
    "goodFor:friends",
    "goodFor:friends-catchup",
    "goodFor:solo-trip",
    "meals:breakfast",
    "meals:brunch",
    "meals:lunch",
    "meals:dinner",
    "meals:quick-bites",
    "cuisine:african",
    "cuisine:american",
    "cuisine:asian",
    "cuisine:british",
    "cuisine:chinese",
    "cuisine:french",
    "cuisine:greek",
    "cuisine:indian",
    "cuisine:italian",
    "cuisine:japanese",
    "cuisine:latin",
    "cuisine:mediterranean",
    "cuisine:mexican",
    "cuisine:middle-eastern",
    "cuisine:scandinavian",
    "cuisine:seafood",
    "cuisine:spanish",
    "cuisine:steakhouse",
    "activities:adventurous",
    "activities:beach",
    "activities:city-break",
    "activities:cultural",
    "activities:hiking",
    "activities:nature",
    "activities:sea",
    "activities:safari",
    "activities:skiing",
]);

export type CatalogItemTag = z.infer<typeof CatalogItemTagSchema>;

export const CatalogItemSchema = z.object({
    id: z.string(),
    name: z.string(),
    nameEn: z.string(),
    imageUrls: z.array(z.string()),
    headline: z.string().nullable(),
    benefits: z.string().nullable(),
    localInsights: z.string().nullable(),
    address: z.string().nullable(),
    description: z.string().nullable(),
    cityGuideLocationKey: z.string().nullable(),
    keyDetail: z.string().nullable(),
    keyDetailEn: z.string().nullable(),
    location: ConciergeGeoPointSchema.nullable(),
    website: z.string().nullable(),
    tags: z.array(CatalogItemTagSchema),
    categories: z.array(z.string()),
    googlePlaceData: CatalogItemGooglePlaceDataSchema.nullable(),
});

export type CatalogItem = z.infer<typeof CatalogItemSchema>;

/**
 * Query parameters for fetching general chat messages.
 */
export const GetGeneralChatMessagesQuerySchema = z.object({
    cursor: z.string().min(1).optional(),
    limit: z.coerce.number().int().gte(1).lte(100).optional(),
});

export type GetGeneralChatMessagesQuery = z.infer<
    typeof GetGeneralChatMessagesQuerySchema
>;

/**
 * Path parameters for fetching request chat messages.
 */
export const GetRequestChatMessagesPathParamsSchema = z.object({
    requestId: z.string().min(1),
});

export type GetRequestChatMessagesPathParams = z.infer<
    typeof GetRequestChatMessagesPathParamsSchema
>;

/**
 * Query parameters for fetching request chat messages.
 */
export const GetRequestChatMessagesQuerySchema = z.object({
    cursor: z.string().min(1).optional(),
    limit: z.coerce.number().int().gte(1).lte(100).optional(),
});

export type GetRequestChatMessagesQuery = z.infer<
    typeof GetRequestChatMessagesQuerySchema
>;

export const SendMessageCatalogItemAttachmentSchema = z.object({
    type: z.literal("catalog-item"),
    id: z.string().min(1),
});

export type SendMessageCatalogItemAttachment = z.infer<
    typeof SendMessageCatalogItemAttachmentSchema
>;

export const SendMessageFileAttachmentSchema = z.object({
    type: z.literal("file"),
    fileUploadId: z.string().min(1),
});

export type SendMessageFileAttachment = z.infer<typeof SendMessageFileAttachmentSchema>;

export const SendGeneralChatMessageAttachmentSchema = z.union([
    z
        .object({
            type: z.literal("catalog-item"),
        })
        .and(SendMessageCatalogItemAttachmentSchema),
    z
        .object({
            type: z.literal("file"),
        })
        .and(SendMessageFileAttachmentSchema),
]);

export type SendGeneralChatMessageAttachment = z.infer<
    typeof SendGeneralChatMessageAttachmentSchema
>;

/**
 * Request body for sending a message in chat.
 */
export const SendGeneralChatMessageRequestSchema = z.object({
    message: z.string(),
    messageHtml: z.string().min(1).optional(),
    idempotencyKey: z.string().min(1).optional(),
    replyToMessageId: z.string().min(1).optional(),
    attachments: z.array(SendGeneralChatMessageAttachmentSchema).optional(),
});

export type SendGeneralChatMessageRequest = z.infer<
    typeof SendGeneralChatMessageRequestSchema
>;

export const SendMessageConfirmedBookingAttachmentSchema = z.object({
    type: z.literal("confirmed-booking"),
    id: z.string().min(1),
    optionId: z.string().nullish(),
});

export type SendMessageConfirmedBookingAttachment = z.infer<
    typeof SendMessageConfirmedBookingAttachmentSchema
>;

export const SendRequestChatMessageAttachmentSchema = z.union([
    z
        .object({
            type: z.literal("catalog-item"),
        })
        .and(SendMessageCatalogItemAttachmentSchema),
    z
        .object({
            type: z.literal("confirmed-booking"),
        })
        .and(SendMessageConfirmedBookingAttachmentSchema),
    z
        .object({
            type: z.literal("file"),
        })
        .and(SendMessageFileAttachmentSchema),
]);

export type SendRequestChatMessageAttachment = z.infer<
    typeof SendRequestChatMessageAttachmentSchema
>;

/**
 * Request body for sending a message in chat.
 */
export const SendRequestChatMessageRequestSchema = z.object({
    message: z.string(),
    messageHtml: z.string().min(1).optional(),
    idempotencyKey: z.string().min(1).optional(),
    replyToMessageId: z.string().min(1).optional(),
    attachments: z.array(SendRequestChatMessageAttachmentSchema).optional(),
});

export type SendRequestChatMessageRequest = z.infer<
    typeof SendRequestChatMessageRequestSchema
>;

/**
 * Path parameters for sending a request chat message.
 */
export const SendRequestChatMessagePathParamsSchema = z.object({
    requestId: z.string().min(1),
});

export type SendRequestChatMessagePathParams = z.infer<
    typeof SendRequestChatMessagePathParamsSchema
>;

/**
 * Path parameters for marking conversation messages as read.
 */
export const MarkConversationMessagesReadPathParamsSchema = z.object({
    conversationId: z.string().min(1),
});

export type MarkConversationMessagesReadPathParams = z.infer<
    typeof MarkConversationMessagesReadPathParamsSchema
>;

/**
 * Optional scope for marking messages as read.
 */
export const MarkConversationMessagesReadRequestSchema = z.object({
    requestId: z.string().min(1).nullish(),
});

export type MarkConversationMessagesReadRequest = z.infer<
    typeof MarkConversationMessagesReadRequestSchema
>;

/**
 * Path parameters for streaming request chat events.
 */
export const StreamRequestChatEventsPathParamsSchema = z.object({
    requestId: z.string().min(1),
});

export type StreamRequestChatEventsPathParams = z.infer<
    typeof StreamRequestChatEventsPathParamsSchema
>;

export const ChatMessageMemberSenderSchema = z.object({
    type: z.literal("member"),
    memberId: z.string().min(1),
    name: z.string().min(1),
});

export type ChatMessageMemberSender = z.infer<typeof ChatMessageMemberSenderSchema>;

export const ChatMessageAgentSenderSchema = z.object({
    type: z.literal("agent"),
    agentId: z.string().min(1),
    name: z.string().min(1),
    avatarUrl: z.string().nullable(),
});

export type ChatMessageAgentSender = z.infer<typeof ChatMessageAgentSenderSchema>;

export const ChatMessageSenderSchema = z.union([
    z
        .object({
            type: z.literal("member"),
        })
        .and(ChatMessageMemberSenderSchema),
    z
        .object({
            type: z.literal("agent"),
        })
        .and(ChatMessageAgentSenderSchema),
]);

export type ChatMessageSender = z.infer<typeof ChatMessageSenderSchema>;

/**
 * Latest message on the request thread, used for inbox avatars.
 */
export const RequestConversationLastMessageSchema = z.object({
    sender: ChatMessageSenderSchema,
});

export type RequestConversationLastMessage = z.infer<
    typeof RequestConversationLastMessageSchema
>;

/**
 * Request thread row for the member conversation inbox.
 */
export const RequestConversationItemSchema = z.object({
    requestId: z.string().min(1),
    title: z.string().nullable(),
    unreadMessagesCount: z.int().gte(0),
    status: z.enum(["new", "open", "confirmed", "closed"]),
    startDate: z.string().nullable(),
    startTime: ClockTimeSchema.nullable(),
    endDate: z.string().nullable(),
    endTime: ClockTimeSchema.nullable(),
    numberOfGuests: z.int().nullable(),
    nextDeadline: RequestConversationDeadlineSchema.nullable(),
    assignedToAgent: RequestConversationAssignedAgentSchema.nullable(),
    lastMessage: RequestConversationLastMessageSchema.nullable(),
});

export type RequestConversationItem = z.infer<typeof RequestConversationItemSchema>;

/**
 * Request threads grouped for the conversation inbox.
 */
export const RequestConversationsSchema = z.object({
    awaitingReview: z.array(RequestConversationItemSchema),
    inProgress: z.array(RequestConversationItemSchema),
    closed: z.array(RequestConversationItemSchema),
});

export type RequestConversations = z.infer<typeof RequestConversationsSchema>;

/**
 * Conversation inbox for the authenticated member.
 */
export const MyConversationsSchema = z.object({
    general: GeneralConversationSummarySchema,
    request: RequestConversationsSchema,
});

export type MyConversations = z.infer<typeof MyConversationsSchema>;

export const SuccessResponseMyConversationsSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: MyConversationsSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseMyConversations = z.infer<
    typeof SuccessResponseMyConversationsSchema
>;

export const CatalogItemMessageAttachmentSchema = z.object({
    type: z.literal("catalog-item"),
    id: z.string().min(1),
    name: z.string().min(1),
    keyDetail: z.string().nullable(),
    imageUrl: z.string().nullable(),
});

export type CatalogItemMessageAttachment = z.infer<
    typeof CatalogItemMessageAttachmentSchema
>;

export const FileMessageAttachmentSchema = z.object({
    type: z.literal("file"),
    url: z.string(),
    mimeType: z.string(),
    filename: z.string(),
});

export type FileMessageAttachment = z.infer<typeof FileMessageAttachmentSchema>;

export const ChatMessageAttachmentSchema = z.union([
    z
        .object({
            type: z.literal("catalog-item"),
        })
        .and(CatalogItemMessageAttachmentSchema),
    z
        .object({
            type: z.literal("file"),
        })
        .and(FileMessageAttachmentSchema),
]);

export type ChatMessageAttachment = z.infer<typeof ChatMessageAttachmentSchema>;

export const ChatMessageBookingOptionSchema = z.object({
    id: z.string().min(1),
    title: z.string(),
});

export type ChatMessageBookingOption = z.infer<typeof ChatMessageBookingOptionSchema>;

export const ChatMessageBookingSummarySchema = z.object({
    id: z.string().min(1),
    title: z.string(),
    imageUrl: z.string().nullable(),
});

export type ChatMessageBookingSummary = z.infer<typeof ChatMessageBookingSummarySchema>;

export const ChatMessageProposalSchema = z.object({
    title: z.string(),
    bookings: z.array(ChatMessageBookingSummarySchema).min(1),
});

export type ChatMessageProposal = z.infer<typeof ChatMessageProposalSchema>;

export const ChatMessageConfirmedBookingSchema = z.object({
    id: z.string().min(1),
    title: z.string(),
    imageUrl: z.string().nullable(),
    options: z.array(ChatMessageBookingOptionSchema),
});

export type ChatMessageConfirmedBooking = z.infer<
    typeof ChatMessageConfirmedBookingSchema
>;

export const ChatMessageReplySchema = z.object({
    id: z.string().min(1),
    message: z.string(),
    imageUrl: z.string().nullable(),
});

export type ChatMessageReply = z.infer<typeof ChatMessageReplySchema>;

export const ChatMessageSchema = z.object({
    id: z.string().min(1),
    sendingId: z.string().nullish(),
    messageHtml: z.string(),
    attachments: z.array(ChatMessageAttachmentSchema),
    sender: ChatMessageSenderSchema,
    sentAt: z.iso.datetime(),
    memberReaction: EmojiReactionSchema.nullable(),
    requestId: z.string().nullable(),
    requestTitle: z.string().nullable(),
    proposal: ChatMessageProposalSchema.nullable(),
    confirmedBookings: z.array(ChatMessageConfirmedBookingSchema),
    reply: ChatMessageReplySchema.nullable(),
});

export type ChatMessage = z.infer<typeof ChatMessageSchema>;

export const GeneralChatMessagesDataSchema = z.object({
    messages: z.array(ChatMessageSchema),
    nextPageCursor: z.string().nullable(),
    conversationId: z.string().nullable(),
    unreadMessageIds: z.array(z.string().min(1)),
});

export type GeneralChatMessagesData = z.infer<typeof GeneralChatMessagesDataSchema>;

export const SuccessResponseGeneralChatMessagesSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: GeneralChatMessagesDataSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseGeneralChatMessages = z.infer<
    typeof SuccessResponseGeneralChatMessagesSchema
>;

export const RequestChatMessagesDataSchema = z.object({
    messages: z.array(ChatMessageSchema),
    nextPageCursor: z.string().nullable(),
    conversationId: z.string().nullable(),
    unreadMessageIds: z.array(z.string().min(1)),
});

export type RequestChatMessagesData = z.infer<typeof RequestChatMessagesDataSchema>;

export const SuccessResponseRequestChatMessagesSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: RequestChatMessagesDataSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseRequestChatMessages = z.infer<
    typeof SuccessResponseRequestChatMessagesSchema
>;

export const ChatMessageDeletedEventPayloadSchema = z.object({
    id: z.string().min(1),
});

export type ChatMessageDeletedEventPayload = z.infer<
    typeof ChatMessageDeletedEventPayloadSchema
>;

/**
 * The data payload of a chat SSE event. The event type is determined by the SSE `event` field (`message-sent`, `message-edited`, `message-deleted`, or `heartbeat`), and the event ID is in the SSE `id` field.
 */
export const ChatEventPayloadSchema = z.union([
    ChatMessageSchema,
    ChatMessageDeletedEventPayloadSchema,
]);

export type ChatEventPayload = z.infer<typeof ChatEventPayloadSchema>;

export const GetCatalogItemByIdPathParamsSchema = z.object({
    id: z.string().min(1),
});

export type GetCatalogItemByIdPathParams = z.infer<
    typeof GetCatalogItemByIdPathParamsSchema
>;

export const SuccessResponseCatalogItemSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: CatalogItemSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseCatalogItem = z.infer<
    typeof SuccessResponseCatalogItemSchema
>;

export const GetCatalogItemsByThemeIdPathParamsSchema = z.object({
    themeId: z.string().min(1),
});

export type GetCatalogItemsByThemeIdPathParams = z.infer<
    typeof GetCatalogItemsByThemeIdPathParamsSchema
>;

export const GetCatalogItemsByThemeIdQuerySchema = z.object({
    cursor: z.string().optional(),
    pageSize: z.coerce.number().int().gte(1).lte(100).optional(),
    cityGuideLocationKey: z.string().min(1).optional(),
    offeringCategory: OfferingCategorySchema.optional(),
});

export type GetCatalogItemsByThemeIdQuery = z.infer<
    typeof GetCatalogItemsByThemeIdQuerySchema
>;

export const GetThemeFacetsPathParamsSchema = z.object({
    themeId: z.string().min(1),
});

export type GetThemeFacetsPathParams = z.infer<typeof GetThemeFacetsPathParamsSchema>;

export const ThemeFacetCountSchema = z.object({
    value: z.string(),
    count: z.int().gte(1),
});

export type ThemeFacetCount = z.infer<typeof ThemeFacetCountSchema>;

export const ThemeCategoryFacetCountSchema = z.object({
    value: OfferingCategorySchema,
    count: z.int().gte(1),
});

export type ThemeCategoryFacetCount = z.infer<typeof ThemeCategoryFacetCountSchema>;

export const ThemeFacetsSchema = z.object({
    facets: z.object({
        categories: z.array(ThemeCategoryFacetCountSchema),
        cities: z.array(ThemeFacetCountSchema),
    }),
});

export type ThemeFacets = z.infer<typeof ThemeFacetsSchema>;

export const SuccessResponseThemeFacetsSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: ThemeFacetsSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseThemeFacets = z.infer<
    typeof SuccessResponseThemeFacetsSchema
>;

export const CatalogItemsByThemeDataSchema = z.object({
    catalogItems: z.array(CatalogItemSchema),
    totalItems: z.int(),
    nextPageCursor: z.string().nullable(),
});

export type CatalogItemsByThemeData = z.infer<typeof CatalogItemsByThemeDataSchema>;

export const SuccessResponseCatalogItemsByThemeSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: CatalogItemsByThemeDataSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseCatalogItemsByTheme = z.infer<
    typeof SuccessResponseCatalogItemsByThemeSchema
>;

export const ImageAttachmentSchema = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    croppedImageURL: z.string().optional(),
    mimeType: z.string().optional(),
});

export type ImageAttachment = z.infer<typeof ImageAttachmentSchema>;

export const AttachmentSchema = z.object({
    id: z.string().optional(),
    url: z.string().optional(),
    filename: z.string().optional(),
    mimeType: z.string().optional(),
});

export type Attachment = z.infer<typeof AttachmentSchema>;

export const PriceSchema = z.object({
    currency: z.string().length(3),
    amount: z.number().gte(0),
});

export type Price = z.infer<typeof PriceSchema>;

export const GeoPointSchema = z.object({
    latitude: z.number().optional(),
    longitude: z.number().optional(),
});

export type GeoPoint = z.infer<typeof GeoPointSchema>;

export const BookingOptionSchema = z.object({
    id: z.string().optional(),
    title: z.string().optional(),
    description: z.string().optional(),
    confirmed: z.boolean().optional(),
    images: z.array(ImageAttachmentSchema).optional(),
    price: PriceSchema.optional(),
});

export type BookingOption = z.infer<typeof BookingOptionSchema>;

/**
 * Member-facing booking payload used by the Concierge app.
 */
export const MemberBookingSchema = z.object({
    id: z.string().min(1),
    title: z.string().optional(),
    description: z.string().optional(),
    offeringCategory: z.string().optional(),
    imageURL: z.string().optional(),
    croppedImageURL: z.string().optional(),
    images: z.array(ImageAttachmentSchema).optional(),
    attachments: z.array(AttachmentSchema).optional(),
    startTime: z.iso.datetime().optional(),
    startTimezone: z.string().optional(),
    endTime: z.iso.datetime().optional(),
    endTimezone: z.string().optional(),
    numberOfGuests: z.number().optional(),
    numberOfNights: z.number().optional(),
    website: z.string().optional(),
    address: z.string().optional(),
    phoneNumber: z.string().optional(),
    geoPoint: GeoPointSchema.optional(),
    googleUrl: z.string().optional(),
    notesForMember: z.string().optional(),
    notesForMemberSenderName: z.string().optional(),
    rooms: z.string().optional(),
    benefits: z.string().optional(),
    price: PriceSchema.optional(),
    priceDetails: z.string().optional(),
    reference: z.string().optional(),
    request: z.string().optional(),
    bookingRating: z.number().optional(),
    bookingFeedback: z.string().optional(),
    headline: z.string().optional(),
    bookingPolicy: z.string().optional(),
    reservationStatus: z.string().optional(),
    options: z.array(BookingOptionSchema).optional(),
});

export type MemberBooking = z.infer<typeof MemberBookingSchema>;

/**
 * Query parameters for paginating member bookings.
 */
export const MemberBookingsQuerySchema = z.object({
    limit: z.coerce.number().int().gte(1).lte(100).optional().default(20),
    cursor: z.string().min(1).optional(),
});

export type MemberBookingsQuery = z.infer<typeof MemberBookingsQuerySchema>;

/**
 * Query parameters for paginating upcoming member bookings.
 */
export const MemberUpcomingBookingsQuerySchema = z.object({
    limit: z.coerce.number().int().gte(1).lte(100).optional().default(3),
    cursor: z.string().min(1).optional(),
});

export type MemberUpcomingBookingsQuery = z.infer<
    typeof MemberUpcomingBookingsQuerySchema
>;

export const MemberBookingsDataSchema = z.object({
    bookings: z.array(MemberBookingSchema),
});

export type MemberBookingsData = z.infer<typeof MemberBookingsDataSchema>;

export const MemberBookingsPageDataSchema = z.object({
    bookings: z.array(MemberBookingSchema),
    nextCursor: z.string().nullable(),
});

export type MemberBookingsPageData = z.infer<typeof MemberBookingsPageDataSchema>;

export const MemberBookingsResponseSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: MemberBookingsDataSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type MemberBookingsResponse = z.infer<typeof MemberBookingsResponseSchema>;

export const MemberBookingsPageResponseSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: MemberBookingsPageDataSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type MemberBookingsPageResponse = z.infer<
    typeof MemberBookingsPageResponseSchema
>;

export const MemberBookingResponseSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: MemberBookingSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type MemberBookingResponse = z.infer<typeof MemberBookingResponseSchema>;

export const InitiateFileUploadRequestSchema = z.object({
    uploadType: z.enum(["chat-message-attachment", "member-avatar"]),
    mimeType: z.string().min(1),
    fileName: z.string().min(1),
});

export type InitiateFileUploadRequest = z.infer<typeof InitiateFileUploadRequestSchema>;

export const InitiateFileUploadDataSchema = z.object({
    id: z.uuid(),
    uploadUrl: z.url(),
    uploadHeaders: z.record(z.string(), z.string()),
    uploadHttpMethod: z.enum(["put", "post"]),
});

export type InitiateFileUploadData = z.infer<typeof InitiateFileUploadDataSchema>;

export const SuccessResponseInitiateFileUploadSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: InitiateFileUploadDataSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseInitiateFileUpload = z.infer<
    typeof SuccessResponseInitiateFileUploadSchema
>;

export const FinalizeFileUploadPathParamsSchema = z.object({
    id: z.uuid(),
});

export type FinalizeFileUploadPathParams = z.infer<
    typeof FinalizeFileUploadPathParamsSchema
>;

export const FinalizeFileUploadDataSchema = z.object({
    status: z.enum(["finalized", "rejected"]),
});

export type FinalizeFileUploadData = z.infer<typeof FinalizeFileUploadDataSchema>;

export const SuccessResponseFinalizeFileUploadSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: FinalizeFileUploadDataSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseFinalizeFileUpload = z.infer<
    typeof SuccessResponseFinalizeFileUploadSchema
>;

export const GetAgentAvatarThumbnailPathParamsSchema = z.object({
    agentId: z.string().min(1),
});

export type GetAgentAvatarThumbnailPathParams = z.infer<
    typeof GetAgentAvatarThumbnailPathParamsSchema
>;

export const AvatarThumbnailUrlSchema = z.object({
    url: z.url().nullable(),
});

export type AvatarThumbnailUrl = z.infer<typeof AvatarThumbnailUrlSchema>;

export const SuccessResponseAvatarThumbnailUrlSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: AvatarThumbnailUrlSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseAvatarThumbnailUrl = z.infer<
    typeof SuccessResponseAvatarThumbnailUrlSchema
>;

export const ChangeMyAvatarRequestSchema = z.object({
    fileUploadId: z.uuid(),
});

export type ChangeMyAvatarRequest = z.infer<typeof ChangeMyAvatarRequestSchema>;

export const ChangeMyAvatarDataSchema = z.object({
    url: z.url(),
});

export type ChangeMyAvatarData = z.infer<typeof ChangeMyAvatarDataSchema>;

export const SuccessResponseChangeMyAvatarSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: ChangeMyAvatarDataSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseChangeMyAvatar = z.infer<
    typeof SuccessResponseChangeMyAvatarSchema
>;

/**
 * A content theme with id and name.
 */
export const ThemeSchema = z.object({
    id: z.string(),
    name: z.string(),
    image: z.string().nullish(),
});

export type Theme = z.infer<typeof ThemeSchema>;

/**
 * A city guide theme
 */
export const CityGuideThemeSchema = ThemeSchema.and(
    z.object({
        cityGuideLocationKey: z.string(),
    }),
);

export type CityGuideTheme = z.infer<typeof CityGuideThemeSchema>;

/**
 * A category theme
 */
export const CategoryThemeSchema = ThemeSchema;

export type CategoryTheme = z.infer<typeof CategoryThemeSchema>;

/**
 * Content themes personalized for a member.
 */
export const DiscoverThemesSchema = z.object({
    spotlightTheme: ThemeSchema.nullable(),
    cityGuideThemes: z.array(CityGuideThemeSchema),
    categoryThemes: z.array(CategoryThemeSchema),
    personalisedThemes: z.array(ThemeSchema),
});

export type DiscoverThemes = z.infer<typeof DiscoverThemesSchema>;

export const SuccessResponseDiscoverThemesSchema = z.object({
    status: z.int(),
    success: z.literal(true),
    data: DiscoverThemesSchema,
    warnings: z.array(z.string()).optional(),
    requestId: z.string().optional(),
});

export type SuccessResponseDiscoverThemes = z.infer<
    typeof SuccessResponseDiscoverThemesSchema
>;
